import { render, staticRenderFns } from "./PremiumSubscribe.vue?vue&type=template&id=65db28be"
import script from "./PremiumSubscribe.vue?vue&type=script&lang=js"
export * from "./PremiumSubscribe.vue?vue&type=script&lang=js"
import style0 from "./PremiumSubscribe.vue?vue&type=style&index=0&id=65db28be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports